import { Hub } from "aws-amplify/utils";

/** The page to come back to after the hosted sign-in, sent as the OAuth custom state. */
export const signInReturnPath = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

/**
 * Brings a user who was sent to sign in from a deep link (such as an emailed
 * task link) back to that page. Register it before Amplify completes the OAuth
 * redirect; only paths on this origin are followed.
 */
export const returnAfterSignIn = (navigate: (path: string) => void): void => {
  Hub.listen("auth", ({ payload }) => {
    if (payload.event !== "customOAuthState") return;
    const path = sameOriginPath(payload.data);
    if (path) navigate(path);
  });
};

const sameOriginPath = (value: string): string | null => {
  let url: URL;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return null;
  }
  return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
};
